<template>
    <div class="content">
        <div class="page_searcher">
            <Searcher :items="config.searchers" @search="getData" ref="searcher"/>
        </div>
        <div v-if="modules.length==1 && !reload">
            <div class="page_block" v-if="modules[0].no_chart!=true">
                <h3>{{modules[0].chart.title}}
                    <ChartTrans v-if="modules[0].chart.summary && modules[0].chart.type!='mixin'" :fields="modules[0].fields" :chart="modules[0].chart" :datas="datas[0]" v-model="modules[0].trans_chart"  style="float:right"/>
                    <!-- <Mark :id="$route.query.id" :chart="modules[0].chart" style="float:right"/> -->
                </h3>
                <div class="page_block_content">
                   <Chart :datas="modules[0].trans_chart?modules[0].trans_chart.data:datas[0]" :fields="modules[0].fields" :conf="modules[0].trans_chart?modules[0].trans_chart.config:modules[0].chart" :height="400"/>
                </div>
            </div>
            <div class="page_block" v-if="modules[0].no_table!=true">
                <h3>{{modules[0].name}}
                    <a-button-group style="float:right; margin:0 0 0 10px" >
                        <!-- <Mark style="margin:0 16px 0 0;" v-if="$route.query.proj='mn1' && mark_permission" :table="isMark(datas[0], modules[0].fields)" :id="$route.query.id" /> -->
                        <a-button @click="lockHeader(0)" :type="locks.indexOf(0)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(0)>=0?$t("common.cancelFix"):$t("common.fixHead")}}</a-button>
                        <a-button @click="exportToExcel(0)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>{{$t("common.downloadData")}}</a-button>
                        <a-button @click="copy(0)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>{{$t("common.copyData")}}</a-button>
                    </a-button-group>
                </h3>
                <template v-if="infos[0]">
                    <div class="page-block-info" style="padding: 20px 30px 0 30px;" v-html="getInfo(modules[0].infos, infos[0], datas[0])" v-if="infos[0] instanceof Object && infos[0].text"></div>
                    <div class="table-summary" v-html="infos[0]" v-else></div>
                </template>
                <div class="page_block_content">
                    <DataTable :liucun="modules[0].liucun" :fields="modules[0].fields" :theads="modules[0].theads" :datas="datas[0]" ref="datatable_0" :pageSize="config.pageSize" :marks="marks" :xlen="modules[0].xlen" :color="config.color"  :show_index="modules[0].show_index"/>
                </div>
            </div>
        </div>
        <div v-if="modules.length>1 && !reload">
            <div class="page_block">
                <a-tabs v-model="current">
                    <a-tab-pane :tab="m.name" v-for="(m, index) in modules" :key="index">
                        <div class="page_block_content" v-if="current===index">
                            <h3 v-if="modules[index].no_chart!=true">{{modules[index].chart.title}}
                                <!-- <Mark :id="$route.query.id" :chart="modules[index].chart" style="float:right"/> -->
                                <ChartTrans v-if="modules[index].chart.summary && modules[index].chart.type!='mixin'" :fields="modules[index].fields" :chart="modules[index].chart" :datas="datas[index]" v-model="modules[index].trans_chart"  style="float:right"/>
                            </h3>
                            <Chart v-if="modules[index].no_chart!=true" :datas="modules[index].trans_chart?modules[index].trans_chart.data:datas[index]" :fields="modules[index].fields" :conf="modules[index].trans_chart?modules[index].trans_chart.config:modules[index].chart" :height="400" />
                            <a-divider dashed style="margin:20px 0 10px 0" v-if="modules[index].no_chart!=true && modules[index].no_table!=true"/>
                            <h3 v-if="modules[index].no_table!=true">{{modules[index].no_chart==true?' ':modules[index].name}}
                                <a-button-group style="float:right; margin:0 0 10px 10px" >
                                    <!-- <Mark style="margin:0 16px 0 0;" v-if="$route.query.proj='mn1' && mark_permission" :table="isMark(datas[index], modules[index].fields)" :id="$route.query.id" /> -->
                                    <a-button @click="lockHeader(index)" :type="locks.indexOf(index)>=0?'primary':null"><a-icon type="lock" />{{locks.indexOf(index)>=0?$t("common.cancelFix"):$t("common.fixHead")}}</a-button>
                                    <a-button @click="exportToExcel(index)" v-if="config.downloadForbidden!==true"><a-icon type="download"/>{{$t("common.downloadData")}}</a-button>
                                    <a-button @click="copy(index)" id="copy-btn" v-if="config.downloadForbidden!==true"><a-icon type="copy"/>{{$t("common.copyData")}}</a-button>
                                </a-button-group>
                            </h3>
                            <template v-if="infos[index]">
                                <div class="page-block-info" style="padding: 20px 30px 0 30px;" v-html="getInfo(modules[index].infos, infos[index], datas[index])" v-if="infos[index] instanceof Object && infos[index].text"></div>
                                <div class="table-summary" v-html="infos[index]" v-else></div>
                            </template>
                            <DataTable v-if="modules[index].no_table!=true" :liucun="modules[index].liucun"  :show_index="modules[index].show_index"
                                :fields="modules[index].fields" :theads="modules[index].theads" :datas="datas[index]" :ref="`datatable_${index}`" :pageSize="config.pageSize" :marks="marks" :color="config.color" :xlen="modules[index].xlen"/>
                        </div>
                    </a-tab-pane>
                </a-tabs>
            </div>
        </div>
    </div>
</template>  

<script>
import {ctrlMixin} from '@/utils/ctrlMixin.js'
import Searcher from '@/components/common/search/searcher.vue'
import DataTable from '@/components/common/datatable.vue'
import Chart from '@/components/common/chart/chart.vue'
import Mark from '@/components/common/chart/mark.vue'
import ChartTrans from '@/components/common/chart/chart_trans.vue'
export default {
    mixins: [ctrlMixin],
    components: {
        Searcher,
        DataTable,
        Chart,
        Mark,
        ChartTrans,
    },
    methods: {
        // 获取页面数据
        getData(params) {
            this.loading = true
            this.$service.query(this.queryId, params).then((data)=>{
                let datas = []
                let infos = []
                data.forEach((m, index)=>{
                    if(m.fields) {
                        this.modules[index]['fields'] = m.fields
                    }
                    if(m.theads) {
                        this.modules[index]['theads'] = m.theads
                    }
                    if(m.chart) {
                        this.modules[index]['chart'] = m.chart
                    }
                    datas.push(m.datas?m.datas:[])
                    infos.push(m.infos?m.infos:'')
                })
                this.datas = datas
                this.infos = infos
                this.loading = false 
                
                this.reload = true
                this.$nextTick(()=>{
                    this.reload = false
                })
            }).catch((data)=>{
                this.loading = false
            })
        },
    },
    data() {
        return {
            datas:[[]],
            current:0,
            infos: [],
            reload: false
        }
    },
}
</script>